import styled, { css } from 'styled-components';

export const DatePickerStyled = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  clear: both;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 47px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  -webkit-overflow-scrolling: touch;

  @media (max-width: 767px) {
    position: absolute;
    top: 35px;
    bottom: 0;
    height: auto;
    padding-bottom: 120px;
  }

  @media (min-width: 768px) {
    padding: 0 16px;
    flex-direction: row;
    height: auto !important;
    overflow-y: unset;
    overflow-x: unset;
    padding-top: 0px;
    margin-bottom: 0px;
    margin-top: 0px;
    align-items: unset;
  }
`;

export const datePickerContainerWidth = css`
  width: 308px;
  max-width: 100%;
`;
